import request from "@/utils/request";

// 列表
export function getList(data) {
  return request({
    url: "/api/party_building/get",
    method: "post",
    data,
  });
}
// 详情
export function getDeatil(params) {
  return request({
    url: "/api/party_building/detail",
    method: "get",
    params,
  });
}